import getLabel from "@/utils/getLabel";
import { ItemArquivoSolicitacao } from "./ItemArquivoSolicitacao";
import { ItemArquivoSolicitacaoLink } from "./ItemArquivoSolicitacaoLink";

export function ItemArquivosSolicitacao({ arquivos, servico, setor, id }) {
  return (
    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
      <dt className="text-sm/6 font-medium text-gray-900">Arquivos</dt>
      <dd className="mt-2 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
        <ul role="list" className="divide-y divide-gray-100 rounded-md border border-gray-200">
          {arquivos.map((item, idx) => (
            item.type === "link" ? (
              <ItemArquivoSolicitacaoLink
                key={idx}
                label={getLabel(setor, servico, item.label)}
                link={item.resposta}
                size={item.size}
                id={id}
              />
            ) : (
              <ItemArquivoSolicitacao
                base64String={item.resposta}
                key={idx}
                label={getLabel(setor, servico, item.label)}
              />
            )
          ))}
        </ul>
      </dd>
    </div>
  )
}